<template>
  <a-divider>标签列表</a-divider>
  <a-descriptions :column="1" class="labelCenter">
    <a-descriptions-item label="标签过滤">
      <a-input-search v-model:value="tag.leftTagId"
                      placeholder="输入标签关键字"
                      style="width: 240px"
                      @search="tag.leftTagChange"
                      allow-clear/>
    </a-descriptions-item>
    <a-descriptions-item label="标签列表">
      <a-card style="width: 300px;height:200px;overflow-y: scroll">
        <a-space wrap align="center">
          <a-tag @click="tag.getTagDev(item,true)" style="cursor: pointer" :color="randomHexColor()"
                 v-for="(item,index) in tag.tagListInfo" :key="index">
            {{ item.tagName }}
          </a-tag>
        </a-space>
      </a-card>
    </a-descriptions-item>
    <a-descriptions-item label="查找设备">
      <a-input-search v-model:value="devId"
                      placeholder="输入设备二维码"
                      style="width: 240px"
                      @search="searchDev"
                      allow-clear/>
    </a-descriptions-item>
  </a-descriptions>
  <a-divider>设备列表
    <a-tooltip title="刷新设备列表" color="#2db7f5">
      <a-button type="primary" @click="tag.getTagDev(tag.leftCurrentTag,true)" shape="circle" size="small" :icon="h(RedoOutlined)"/>
    </a-tooltip>
  </a-divider>
  <a-collapse
      v-model:activeKey="activeKey"
      :bordered="false"
      style="background: hsl(180deg, 23%, 97%)"
  >
    <template #expandIcon="{ isActive }">
      <caret-right-outlined :rotate="isActive ? 90 : 0"/>
    </template>
    <a-collapse-panel key="1" :header="tag.leftCurrentTag.tagName" style="border: none">
      <template #extra v-if="Object.keys(tag.currentTagListInfo).length">
        总数:{{ tag.currentTagListInfo.total }} 在线:{{ tag.currentTagListInfo.online }}
        掉线:{{ Number(tag.currentTagListInfo.total) - Number(tag.currentTagListInfo.online) }}
      </template>
      <template #extra v-else>
        总数:0 在线:0
        掉线:0
      </template>
      <a-descriptions :column="3" class="labelCenter" v-if="Object.keys(tag.currentTagListInfo).length">
        <a-descriptions-item v-for="item in tag.currentTagListInfo.devices" :key="item.uniqueCode">
          <a-space @click="single.changeCurrentCode(item.uniqueCode,tag.currentTagListInfo.devices,'nolist')"
                   :style="single.currentCode.qrCode === item.uniqueCode ? 'background:pink' :''">
            <span class="code" style="color: #70b1e3" v-if="item.online === 1">{{ item.uniqueCode }}</span>
            <s class="code" v-else>{{ item.uniqueCode }}</s>
          </a-space>
        </a-descriptions-item>
      </a-descriptions>
      <a-empty :image="simpleImage" v-else/>
    </a-collapse-panel>
  </a-collapse>
</template>
<script setup>
import tagList from "@/layouts/admin-sidebar/tag/list/tagList";
import {CaretRightOutlined, RedoOutlined} from "@ant-design/icons-vue";
import {Empty} from 'ant-design-vue';
import tagStore from "@/stores/tagStore";
import singleDev from "@/stores/singleDev";
import {h} from "vue";

let tag = tagStore();
let single = singleDev();

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
let {
  randomHexColor,
  devId,
  searchDev,
  activeKey
} = tagList();
</script>

<style scoped lang="scss">
.code {
  cursor: pointer;
}
</style>
